module.exports = __webpack_public_path__ + "1308e168692196fd969b5209eca22935.ttf";